<div class="embedded-component-icon cross-arrows-icon">
  <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 4.5L14 0.5V3.5H7V5.5H14V8.5M4 6.5L0 10.5L4 14.5V11.5H11V9.5H4V6.5Z" fill="#0046AD"/>
  </svg>
</div>
